export default __webpack_public_path__ + "static/media/elephant.46f04c8c.png";